import React from 'react';
export const ZoneStoreContext = React.createContext(undefined);
export const useZoneStore = () => React.useContext(ZoneStoreContext);
